import { useEffect, useRef, useState } from 'react';
import StyledChatToggleButtonBubble from '../../styles/StyledChatToggleButtonBubble';
import ChatToggleButtonBubbleContainer from '../ChatToggleButtonBubbleContainer/ChatToggleButtonBubbleContainer';
import CloseBubbleButton from '../CloseBubbleButton/CloseBubbleButton';

interface ChatToggleButtonBubbleProps {
  text: string;
  close: () => void;
}

const ChatToggleButtonBubble = ({ text, close }: ChatToggleButtonBubbleProps) => {
  const [textToDisplay, setTextToDisplay] = useState('');
  const letterIndex = useRef(0);
  const timeOutRef = useRef<NodeJS.Timeout | null>(null);

  const animateText = () => {
    if (letterIndex.current >= text.length) {
      timeOutRef.current && clearTimeout(timeOutRef.current);
      return;
    };

    timeOutRef.current = setTimeout(() => {
      setTextToDisplay(textToDisplay + text[letterIndex.current]);
      
      letterIndex.current++;
    }, 20);
  };

  useEffect(() => {
    animateText();

    return () => { 
      timeOutRef.current && clearTimeout(timeOutRef.current); 
    };
  }, [textToDisplay]);

  return (
    <ChatToggleButtonBubbleContainer>
      <CloseBubbleButton onClick={close} />
      <StyledChatToggleButtonBubble>
        {textToDisplay}
      </StyledChatToggleButtonBubble>
    </ChatToggleButtonBubbleContainer>
  );
};

export default ChatToggleButtonBubble;